<template>
    <div class="est-price-container" ref="estPrice">
        <span class="text">{{ cmpEstPriceText }}</span>
        <template v-if="estPriceValue">
            <h3 class="value">
                {{ $ft.formatCurrency({ value:estPriceValue, noSpace:true, units: true, currencySymbol}) }}
            </h3>
            <div class="popper">
                <p
                    class="tip"
                    ref="tip"
                    v-click="{ selector: '.contact-us', callback: request }"
                    v-html="$t('md-sold-detail.thisIsAGeneralEstimate')"
                ></p>
            </div>
        </template>
        <template v-else>
            <span class="value">?</span>
            <div class="popper">
                <p
                    class="tip"
                    ref="tip"
                    v-click="{ selector: '.contact-us', callback: request }"
                    v-html="$t('md-sold-detail.forMoreInformation')"
                ></p>
            </div>
        </template>
    </div>
</template>

<script>
import signLog from '@/components/sign-log';
import API from '../api';
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from "@/store";
import { mapState } from '@/store/helpers';
export default {
    i18next: {
        ns: 'md-sold-detail'
    },
    data: function() {
        return {
            estPriceValue: 0
        };
    },
    computed: {
        cmpEstPriceText() {
            return this.$t('md-sold-detail.estprice');
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        ...rootMapState(usePageStore, {
            currencySymbol: store => store.currency?.symbol,
        }),
        ...mapState({
            info: store => store.listingDetail.info || {}
        })
    },
    beforeMount() {
        this.getEstPrice();
    },
    mounted() {
        if (this.isMobileSize) {
            this.$nextTick(() => {
                this.calcTipStyle();
            });
        }
    },
    methods: {
        getEstPrice() {
            let { cityAddress, streetAddress } = this.info;
            if (cityAddress && streetAddress) {
                API.getEstPrice.call(this, {
                    address: `${streetAddress}, ${cityAddress}`
                }).then(({ data }) => {
                    if (data && data.zestimate) {
                        this.estPriceValue = Number(data.zestimate.amount) || 0;
                    }
                });
            }
        },
        request() {
            signLog.register(
                {
                    registerTitle: null,
                    submitRegister: null
                },
                'evaluationRegister'
            );
        },
        calcTipStyle() {
            let parent = this.$refs.estPrice;
            let overWidth =
                parent.getBoundingClientRect().x + 280 - window.innerWidth;
            // tip whether the box extends beyond the right  tip width：280 fixed dead
            if (overWidth > 0) {
                this.$refs.tip.style.transform = `translateX(-${
                    overWidth + 15
                }px)`;
            }
        }
    }
};
</script>

<style lang="scss">
.est-price-container {
    h3 {
        font-size: 14px;
        display: inline-block;
        font-weight: normal;
        line-height: normal;
    }
    position: relative;
    cursor: pointer;
    z-index: var(--level-low);
    .popper {
        padding-top: 30px;
        display: none;
        position: absolute;
        top: 0;
        width: 100%;
        .tip {
            padding: 10px;
            font-size: 12px;
            width: 310px;
            margin: 0;
            cursor: default;
            .contact-us {
                color: #4c84ff;
                cursor: pointer;
            }
            @media (max-width: 600px) {
                width: 280px;
            }
        }
    }
    &:hover {
        .popper {
            display: block;
        }
    }
}
.md-sold-detail.classic {
    .est-price-container {
        color: #313b42;
        font-size: 14px;
        .popper {
            &:before {
                content: '';
                position: absolute;
                top: 25px;
                left: 50%;
                width: 10px;
                height: 10px;
                border: 1px solid #ebecf0;
                transform: rotate(45deg);
                border: solid 1px #ebecf0;
                background-color: #ffffff;
                border-right: none;
                border-bottom: none;
                z-index: var(--level-low); //  cover tip
            }
            .tip {
                color: #202437;
                font-size: 12px;
                box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
                border: solid 1px #ebecf0;
                line-height: 1.5;
                background-color: #ffffff;
            }
        }
        border-bottom: 1px solid #313b42;
    }
    //  Covering the ceiling bar
    .pc-fixed-banner {
        .est-price-container {
            border-bottom: none;
        }
    }
}
.md-sold-detail.standard {
    .est-price-container {
        color: #515666;
        font-size: 14px;
        .popper {
            &:before {
                content: '';
                position: absolute;
                top: 25px;
                left: 50%;
                width: 10px;
                height: 10px;
                border: 1px solid #ebecf0;
                transform: rotate(45deg);
                border: solid 1px #ebecf0;
                background-color: #ffffff;
                border-right: none;
                border-bottom: none;
                z-index: var(--level-low); //  cover tip
            }
            .tip {
                color: #535868;
                font-size: 12px;
                box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
                border: solid 1px #ebecf0;
                line-height: 1.5;
                background-color: #ffffff;
            }
        }
        border-bottom: 1px solid #515666;
    }
}
.md-sold-detail.fashion {
    .est-price-container {
        color: #ffffff;
        font-size: 14px;
        .popper {
            &:before {
                content: '';
                position: absolute;
                top: 25px;
                left: 50%;
                width: 10px;
                height: 10px;
                border: 1px solid #ebecf0;
                transform: rotate(45deg);
                border: solid 1px #ebecf0;
                background-color: #ffffff;
                border-right: none;
                border-bottom: none;
                z-index: var(--level-low); //  cover tip
            }
            .tip {
                color: #4a4a60;
                font-size: 12px;
                box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
                border: solid 1px #ebecf0;
                line-height: 1.5;
                background-color: #ffffff;
                border-radius: 2px;
            }
        }
        border-bottom: 1px solid #ffffff;
        @media (max-width: 600px) {
            border-bottom: 0.5px solid #ffffff;
        }
    }
    //  Covering the ceiling bar
    .pc-fixed-banner {
        .est-price-container {
            border-bottom: none;
        }
    }
}

.md-sold-detail.broker {
    &.mobile .est-price-container {
        h1,
        h2,
        h3 {
            font-size: 12px;
        }
    }
    .est-price-container {
        color: #313b42;
        .popper {
            &:before {
                content: '';
                position: absolute;
                top: 25px;
                left: 50%;
                width: 10px;
                height: 10px;
                border: 1px solid #ebecf0;
                transform: rotate(45deg);
                border: solid 1px #ebecf0;
                background-color: #ffffff;
                border-right: none;
                border-bottom: none;
                z-index: var(--level-low); //  cover tip
            }
            .tip {
                color: #202437;
                font-size: 12px;
                box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
                border: solid 1px #ebecf0;
                line-height: 1.5;
                background-color: #ffffff;
            }
        }
        border-bottom: 1px solid;
    }
}
</style>
